module.exports = __webpack_public_path__ + "img/43_25.14f38b7b.png";